export const S3URL = {
    manager: "https://smashhaus.s3.amazonaws.com/micro_promotions/SH_microinvestors+companies_One.mp4",
    creator: "https://smashhaus.s3.amazonaws.com/micro_promotions/SH_microinvestors workers_One.mp4",
    netwrk: "https://smashhaus.s3.amazonaws.com/micro_promotions/SH_NETWRK ANNOUNCE_1.mp4",
    netwrkThumbnail: "https://smashhaus.s3.amazonaws.com/micro_promotions/smash_haus_netwrk_thumb.png",
    microPromotionThumbnail: "https://smashhaus.s3.amazonaws.com/micro_promotions/micro_promotions_thumb.png",
};
  